var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata",style:(_vm.customStyle)},[(_vm.showObj.img)?_c('img',{attrs:{"src":_vm.showObj.img,"alt":""}}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.showObj.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }